<div class="container">
  <app-back-header (action)="SetAction($event)" [buttonImage]="BackHeaderImageType.Logo" title="{{ 'PAGES.EVENT_OVERVIEW.TITLE' | translate }}"></app-back-header>
  <div class="iframe__wrapper">
    @if (eventUrl$ | async; as eventUrl) {
      <iframe allowfullscreen [src]="eventUrl | safe: 'resourceUrl'"></iframe>
    }
  </div>
</div>

